import { render, staticRenderFns } from "./BulkActions.vue?vue&type=template&id=0443e071&scoped=true&"
import script from "./BulkActions.vue?vue&type=script&lang=js&"
export * from "./BulkActions.vue?vue&type=script&lang=js&"
import style0 from "./BulkActions.vue?vue&type=style&index=0&id=0443e071&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0443e071",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0443e071')) {
      api.createRecord('0443e071', component.options)
    } else {
      api.reload('0443e071', component.options)
    }
    module.hot.accept("./BulkActions.vue?vue&type=template&id=0443e071&scoped=true&", function () {
      api.rerender('0443e071', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessChargesAgGrid/components/BulkActions.vue"
export default component.exports